export const WaterEcosystem = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4624 3.17209L6.44453 9.44435C3.98989 12.5126 4.48741 16.9899 7.55572 19.4445C10.1541 21.5231 13.8462 21.5231 16.4446 19.4444C19.5127 16.9898 20.0102 12.5127 17.5556 9.44452L12.5376 3.17209C12.262 2.82756 11.738 2.82756 11.4624 3.17209Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M16 14C16 15.7631 14.8001 17.3 13.0896 17.7276L12 18"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
